import { timeStringToTimestamp } from "../utils";
import convert from "./convert-units/lib/convert_units";

export default function unitConvertor(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) return value;
  let convertedValue = value;

  // resolve special unit and values to standard unit and numeric value
  if (fromUnit === "h:min:s:ms") {
    value = timeStringToTimestamp(value);
    fromUnit = "ms";
  }

  try {
    convertedValue = convert(value).from(fromUnit.trim()).to(toUnit.trim());
  } catch (e) {
    console.log(
      `[ERROR] Failed to convert unit (from: ${fromUnit}, to: ${toUnit}), error: `,
      e,
    );
    return convertedValue;
  }

  return convertedValue;
}

export const isCovertPossible = (from, to) => {
  if (from === "h:min:s:ms") {
    from = "ms";
  }

  let possibilities;
  try {
    possibilities = convert().from(from).possibilities();
    return possibilities?.includes(to) || false;
  } catch (e) {
    console.log(
      "[ERROR] Failed to check unit conversion possibility, error: ",
      e,
    );
    return false;
  }
};
